import React from 'react';
import { useState, useEffect, useRef } from 'react';
import {
  ConnectionStateToast,
  FocusLayout,
  FocusLayoutContainer,
  GridLayout,
  isTrackReference,
  LayoutContextProvider,
  ParticipantTile,
  RoomAudioRenderer,
  useCreateLayoutContext,
  usePinnedTracks,
  useTracks,
  useLocalParticipant,
  useIsRecording,
} from '@livekit/components-react';
import { RoomEvent, Track } from 'livekit-client';
import { isEqualTrackRef, isWeb } from '@livekit/components-core';
import { View } from '@smarterservices/smarter-ui';
import {
  getStore,
  usePlayerStore,
  useExamSessionStore,
} from '../../../stores/StoreContext';
import CONSTANTS from '../../../config/constants';
import VideoRenderer from '../VideoRenderer';
import SessionTrack from '../../../classes/SessionTrack';
import NoTracksLive from '../NoTracksLive';
import NoTracksRecorded from '../NoTracksRecorded';
import NoVideo from '../NoVideo';

export function SessionLayout({ enabledComponents, ...props }) {
  const ExamSessionStore = getStore('examSessionStore');
  const PlayerStore = getStore('playerStore');
  const isLive = usePlayerStore((state) => state.isLive);
  const muted = usePlayerStore((state) => state.muted);
  const hasTracks = usePlayerStore((state) => state.hasTracks);
  const currentJourneyStepId = useExamSessionStore(
    (state) => state.journey.currentJourneyStepId
  );

  //const participants = useParticipants();
  //const remoteParticipants = useRemoteParticipants();
  const { localParticipant } = useLocalParticipant();
  const isRecording = useIsRecording();

  useEffect(() => {
    //ExamSessionStore.setIsMediaServerRecording(isRecording);
    //console.log('Connection Quality', localParticipant);
  }, [localParticipant]);

  // this tracks more sound than anything, it is not acurate for actual speach...
  //const activeSpeakers = useSpeakingParticipants();

  useEffect(() => {
    ExamSessionStore.setIsMediaServerRecording(isRecording);
    //console.log(isRecording);
  }, [isRecording]);

  const [widgetState, setWidgetState] = useState({
    showChat: false,
    unreadMessages: 0,
    showSettings: false,
  });
  const lastAutoFocusedScreenShareTrack = useRef(null);

  const tracks = useTracks(
    [
      { source: Track.Source.Camera, withPlaceholder: false },
      { source: Track.Source.ScreenShare, withPlaceholder: false },
    ],
    { onlySubscribed: false }
  );

  useEffect(() => {

    if (!hasTracks) return;
    // loop the tracks and create a new Track object for each one...
    tracks.forEach((track) => {
      const sessionTrack = new SessionTrack();
      sessionTrack.populateFromLiveKit(track);
      PlayerStore.addTrack(sessionTrack);
    });
  }, [tracks]);

  const controls = {
    chat: !!enabledComponents?.chat,
    microphone: !!enabledComponents?.microphone,
    screenShare: !!enabledComponents?.screenShare,
    camera: !!enabledComponents?.camera,
    leave: !!enabledComponents?.leave,
    settings: !!enabledComponents?.settings,
  };

  const widgetUpdate = (state) => {
    //console.log('updating widget state', state);
    setWidgetState(state);
  };

  const layoutContext = useCreateLayoutContext();

  const screenShareTracks = tracks
    .filter(isTrackReference)
    .filter((track) => track.publication.source === Track.Source.ScreenShare);

  const focusTrack = usePinnedTracks(layoutContext)?.[0];
  const carouselTracks = tracks.filter(
    (track) => !isEqualTrackRef(track, focusTrack)
  );

  useEffect(() => {
    if (
      lastAutoFocusedScreenShareTrack.current &&
      !screenShareTracks.some(
        (track) =>
          track.publication.trackSid ===
          lastAutoFocusedScreenShareTrack.current?.publication?.trackSid
      )
    ) {
      //console.log('Auto clearing screen share focus.');
      layoutContext.pin.dispatch?.({ msg: 'clear_pin' });
      lastAutoFocusedScreenShareTrack.current = null;
    }
    if (focusTrack && !isTrackReference(focusTrack)) {
      const updatedFocusTrack = tracks.find(
        (tr) =>
          tr.participant.identity === focusTrack.participant.identity &&
          tr.source === focusTrack.source
      );
      if (
        updatedFocusTrack !== focusTrack &&
        isTrackReference(updatedFocusTrack)
      ) {
        layoutContext.pin.dispatch?.({
          msg: 'set_pin',
          trackReference: updatedFocusTrack,
        });
      }
    }
  }, [
    screenShareTracks
      .map(
        (ref) => `${ref.publication.trackSid}_${ref.publication.isSubscribed}`
      )
      .join(),
    focusTrack?.publication?.trackSid,
    tracks,
  ]);

  // Start: Registering All Events...

  // End: Registering all events...
  const renderNoTracksMessage = () => {
    if (!currentJourneyStepId) {
      return <NoVideo />;
    }
    if (isLive) {
      return <NoTracksLive />;
    }
    return <NoTracksRecorded />;
  };

  return (
    <>
      {/* Video Player */}
      {hasTracks ? (
        <>
          <VideoRenderer />
          <RoomAudioRenderer muted={!isLive ? true : muted} />
        </>
      ) : (
        renderNoTracksMessage()
      )}
    </>
  );
}
